import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import styles from './ConnectAccounts.module.scss'
import { ConnectionHubFromScreen, IIntegrationPartner, IpNames } from '../../../interfaces/interfaces';
import { RestS } from '../../../rest/rest-service';
import MeritoButton from '../../../components/common/MeritoButtons/MeritoButtons';
import { VscDebugDisconnect as ConnectIcon } from 'react-icons/vsc'
import CircularLoader from '../../../components/common/CircularLoader/CircularLoader';
import { useAppSelector } from '../../../redux/reduxHooks';
import Connections from '../../Connections/Connections';
import useModal from '../../../components/Hooks/useModal';
import { useSearchParams } from 'react-router-dom';
import { UnderwritingFormContext } from '../context/UnderwritingFormContext';
import { IpRestS } from '../../../rest/ipRest-service';
import { useSpring, animated } from 'react-spring';
import { HiSearch as SearchIcon } from 'react-icons/hi'
import { RiCloseFill as CloseIcon } from 'react-icons/ri'
import { debounce } from 'lodash';
import { BsFillExclamationTriangleFill } from 'react-icons/bs';




const ConnectAccounts = () => {
  const [accountsData, setAccountsData] = useState([]);
  const [loading, setLoading] = useState(true);

  const { dfProgress } = useAppSelector(state => state.dataFetchingProgress);
  const { toggle: connectionToggle, visible: connectionVisible } = useModal();

  const [searchParams, setSearchParams] = useSearchParams();
  // const { formData, formStepsValidity } = useContext(UnderwritingFormContext);
  const [connectedState, setConnectedState] = useState({
    takeState: false,
    ip: null,
    showIpScreen: false,
    fromScreen: null,
  });
  const [ipMappingData, setIpMappingData] = useState({});
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);
  // const animationProps = useSpring({ width: isSearchExpanded ? 600 : 40 });
  const animationProps = useSpring({
    transform: isSearchExpanded ? 'translateX(-0px)' : 'translateX(0px)',
    width: isSearchExpanded ? 600 : 40,
    // config: { tension: 0, friction: 20 }
  });

  const titleAnimation = useSpring({
    opacity: isSearchExpanded ? 0 : 1,
    maxHeight: isSearchExpanded ? 0 : 40, // Ensures smooth hiding
    config: { tension: 250, friction: 20 }
  });
  const searchInputRef = useRef(null);
  const [searchText, setSearchText] = useState('');
  const [debouncedSearchText, setDebouncedSearchText] = useState('');

  const debouncedSearch = useCallback(
    debounce((value) => setDebouncedSearchText(value), 300),
    []
  );

  useEffect(() => {
    if (isSearchExpanded) {
      searchInputRef.current?.focus();
    }
  }, [isSearchExpanded]);


  useEffect(() => {
    debouncedSearch(searchText);
  }, [searchText, debouncedSearch]);


  const formatIpObj = (ipArr: IIntegrationPartner[]) => {
    return ipArr.reduce((prev, curVal) => {
      prev[curVal?.companyName] = {
        ipName: curVal?.companyName,
        isSalesChannel: curVal?.isSalesChannel,
        ...curVal,
      }
      return prev;
    }, {})
  }

  const fetchAccounts = async () => {
    try {
      const allIps = [IpNames.shopify, IpNames.metaAds, IpNames.googleAds, IpNames.googleAnalytics, IpNames.amazonSellerCentral, IpNames.amazonVendorCentral, IpNames.amazonAds];
      const adsChannels = new Set([IpNames.metaAds, IpNames.googleAds, IpNames.amazonAds]);
      const [{ accounts }, activeIpWorkspaces] = await Promise.all([RestS.fetchAccessTokens() as any, IpRestS.getAllIpByStatus().then(res => res.data)]);

      // console.log('active  workspaces', activeIpWorkspaces)

      // console.log('accounts', accounts)
      const groupedAcconts = accounts.reduce((prev, curVal) => {
        prev[curVal.ipName] = curVal;
        return prev;
      }, {});
      const ipMapping = activeIpWorkspaces.reduce((prev, curVal) => {
        if (curVal?.integrationPartner?.combined) {
          prev = {
            ...prev,
            ...formatIpObj(curVal?.integrationPartner?.optionalIp),
            ...formatIpObj(curVal?.integrationPartner?.mandatoryIp),
            ...formatIpObj(curVal?.integrationPartner?.nonMandatoryIp)
          }
        } else {
          prev = {
            ...prev,
            ...formatIpObj([curVal]),
          }
        }
        return prev;
      }, {});

      const sortedIps = [...new Set([...allIps, ...Object.keys(ipMapping)])];


      const allAccountsData = sortedIps.reduce((prev, curVal) => {
        const accountData = groupedAcconts[curVal] ?? { ipName: curVal, isConnected: false, accounts: [] };
        prev.push({
          ...accountData,
          ipLogo: ipMapping[curVal]?.logo,
          isSalesChannel: ipMapping[curVal]?.isSalesChannel,
          isAdsChannel: adsChannels.has(curVal as IpNames)
        });
        return prev;
      }, []);

      console.log('allAccountsData', allAccountsData)
      setIpMappingData(ipMapping);
      setAccountsData(allAccountsData);
    } catch (error) {
      console.log('error', error);
    }
  }

  const clearSearchParam = () => {
    // console.log('searchParams', searchParams);
    console.log("RUNNING clear search params", searchParams)
    // const currentHash = window.location.hash;
    // Preserve the current hash

    if (searchParams.toString().length > 0) {
      searchParams.delete("customers");
      searchParams.delete("ip");
      searchParams.delete("step");
      searchParams.delete("success");
      setSearchParams(searchParams, { replace: true });

      // Check if there was a hash and it's been removed
      // if (currentHash && window.location.hash !== currentHash) {
      //     window.location.hash = currentHash; // Restore the hash manually
      // }
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      await fetchAccounts();
      setLoading(false);
    })();

    if (searchParams.get("connectionHub")) {
      console.log('searchParams')

      searchParams.delete("connectionHub");
      console.log('searchParams', searchParams.toString())
      connectionToggle();
      setSearchParams(searchParams, { replace: true });
    } else {
      console.log('connection hub not present')
    }
  }, []);

  useEffect(() => {
    fetchAccounts();
  }, [dfProgress]);


  // useEffect(() => {
  //     if (!connectionVisible) {
  //         setConnectedState({
  //             takeState: false,
  //             ip: null,
  //             showIpScreen: false,
  //             fromScreen: null,
  //         })
  //     }
  // }, [connectionVisible]);

  const filteredAccountsData = useMemo(() => {
    if (!debouncedSearchText) return accountsData;
    const filtered = accountsData.filter(account =>
      account.ipName.toLowerCase().includes(debouncedSearchText.toLowerCase())
    );
    return filtered.length ? filtered : [];
  }, [debouncedSearchText, accountsData]);

  useEffect(() => {
    console.log('filteredAccountsData', filteredAccountsData);
  }, [filteredAccountsData])


  return (
    <div className={styles.connectAccountsRootContainer}>
      {loading ?
        <div className={styles.loadingContainer}>
          <CircularLoader />
        </div>
        : <div className={styles.connectAccountsWrapper}>
          {
            filteredAccountsData?.filter(item => item.disconnectedAccounts?.length)?.length ?
              <div className={styles.infoBanner}>
                <BsFillExclamationTriangleFill />
                <p>Some accounts may be disconnected due to technical issues. Please reconnect.</p>
              </div> : null
          }
          <div className={styles.sectionHeadingContainer}>
            {/* {<div className={`${styles.title} ${isSearchExpanded ? styles.hidden : ''}`}>
                            Connect All Your Relevant Accounts
                        </div>} */}

            <animated.div style={titleAnimation} className={styles.title}>
              Connect All Your Relevant Accounts
            </animated.div>

            <div className={styles.searchContainer}>
              <animated.div style={animationProps} className={`${styles.searchBar} ${isSearchExpanded ? styles.expanded : ''}`}>
                <div className={`${styles.searchIcon} ${isSearchExpanded ? styles.moveLeft : ''}`}>
                  <SearchIcon />
                </div>
                <input ref={searchInputRef} className={styles.searchInput} type="text" placeholder="Search" value={searchText}
                  onChange={(e) => setSearchText(e.target.value)} />
                <div className={`${styles.searchBtn} ${isSearchExpanded ? styles.expanded : ''}`} onClick={() => {
                  setIsSearchExpanded(!isSearchExpanded);
                  // if (!isSearchExpanded) {
                  //     setTimeout(() => searchInputRef.current?.focus(), 100);
                  // } else {
                  setSearchText('');
                  // }
                }}>
                  {isSearchExpanded ? <CloseIcon /> : <SearchIcon />}
                </div>
              </animated.div>
            </div>
          </div>

          {filteredAccountsData?.length ? <div className={styles.accountsCardOuterContainer}>
            {filteredAccountsData.map((item) => {
              return (
                <div className={styles.gridItemContainer} onClick={() => {
                  setConnectedState({
                    takeState: true,
                    ip: ipMappingData[item.ipName],
                    showIpScreen: true,
                    fromScreen: ConnectionHubFromScreen.underwriting
                  })
                  connectionToggle()
                }}>
                  <div className={styles.ipLogoContainer}>
                    <img src={item.ipLogo} alt="logo" />
                  </div>
                  <div className={styles.ipText}>
                    {item?.ipName}
                  </div>
                  {(item?.accounts && item?.accounts.length) || (item?.inProgressAccounts && item?.inProgressAccounts.length) ? <div className={styles.connectedStatus}>
                    {item?.accounts.length + item?.inProgressAccounts.length} connected
                  </div> : null}
                  {(item?.disconnectedAccounts && item?.disconnectedAccounts?.length) ? <div className={`${styles.connectedStatus} ${styles.disconnected}`}>
                    {item?.disconnectedAccounts.length} disconnected
                  </div> : null}
                </div>
              )
            })}
          </div> : <div className={styles.coldTextContainer}>No channels match your search criteria.</div>}

        </div>}
      <Connections
        toggle={() => {
          connectionToggle();
          setConnectedState({
            takeState: false,
            ip: null,
            showIpScreen: false,
            fromScreen: null,
          })
        }}
        visible={connectionVisible}
        clearParams={clearSearchParam}
        connectedState={connectedState}
        onDisconnectRefresh={() => {
          fetchAccounts();
        }}
      />
    </div>
  );
}

export default ConnectAccounts;